import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import {
  BORDER_WIDTH,
  defaultContext,
  getOuterBorderTexture,
  getInitialStyle,
  getInnerBorderTexture,
} from './focus.style';

export class CoverFocus extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Inner: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._radius = 0;
    this._style = defaultContext;
  }

  get radius() {
    return this._radius;
  }

  set radius(value) {
    if (value !== this._radius) {
      this._radius = value;

      const borderWidth = BORDER_WIDTH[this._style.screenSize];
      const size = this._radius * 2 + borderWidth * 2;

      this.patch({
        w: size,
        h: size,
        texture: getOuterBorderTexture(this._style, this._radius),
        Inner: {
          w: size - borderWidth,
          h: size - borderWidth,
          texture: getInnerBorderTexture(this._style, this._radius),
        },
      });
    }
  }

  get colorMode() {
    return this._colorMode;
  }

  set colorMode(value) {
    if (value !== this._style.colorMode) {
      this._style = {
        screenSize: this._style.screenSize,
        colorMode: value,
      };
      this.patch({
        texture: getOuterBorderTexture(this._style, this._radius),
        Inner: {
          texture: getInnerBorderTexture(this._style, this._radius),
        },
      });
    }
  }
}
